import React, { useCallback, useEffect } from 'react';
import { setTitle } from '../../redux/title/action';
import { useDispatch, useSelector } from 'react-redux';
import { StyledContainer } from '../../components/container/styles';
import { RenderForm } from '../../components/forms';
import { useForm } from 'react-hook-form';
import { FORM_LOGIN_DEALER, FORM_SHOW_LOGGED_IN } from './forms';
import { ButtonTheme } from '../../components/buttons';
import { ContainerButton } from '../../styles/global-style';
import { useGetStoreQr } from './hooks/useGetStoreQr';
import { useLoginDealer } from './hooks/useLoginDealer';
import { useLogoutDealer } from './hooks/useLogoutDealer';
import { ROUTES_PATH } from '../../resources/routes-name';
import { setCookies } from '../../store/useCookies';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Spin } from 'antd';

export const LoginDealer = () => {
  const { control, setValue, getValues, handleSubmit, watch } = useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const profile = useSelector((state) => state?.line?.profile) || {};
  const { storeId } = useSelector((state) => state?.storeQr);
  const { loginSuccess, storeMasterName, storeName, telephone, lineUid } = useSelector(
    (state) => state?.info,
  );
  const { mutate: getStoreQr, isPending: isGetStoreQrPending } = useGetStoreQr();
  const { mutate: loginDealer, isPending: isLoginDealerPending } = useLoginDealer();
  const { mutate: logoutDealer, isPending: isLogoutDealerPending } = useLogoutDealer();
  const { displayName, userId } = profile;

  const storeMasterId = watch('storeMasterId');

  useEffect(() => {
    dispatch(setTitle('เข้าสู่ระบบร้านค้า'));
  }, []);

  useEffect(() => {
    if (storeId) {
      const payload = {
        storeId: storeId,
      };
      getStoreQr(payload, {
        onSuccess: (data) => {
          setValue('storeId', data?.result?.item?.storeMasterName);
          setValue('storeName', data?.result?.item?.storeName);
          setValue('phoneNumber', data?.result?.item?.phoneNumber);
          setValue('storeMasterId', data?.result?.item?.storeMasterId);
        },
      });
    }
  }, [storeId]);

  useEffect(() => {
    if (loginSuccess === true && storeMasterName) {
      setTimeout(() => {
        setValue('storeMasterName', storeMasterName);
        setValue('storeName', storeName);
        setValue('telephone', telephone);
      }, 100);
    }
  }, [loginSuccess, storeMasterName, setValue]);

  const onSubmit = useCallback(
    (data) => {
      if (loginSuccess === true) {
        const payload = {
          lineUid: lineUid,
        };
        logoutDealer(payload);
      } else {
        const encodedData = {
          storeId: storeId,
          lineName: displayName,
          storeMasterId: storeMasterId,
          lineUid: userId,
          password: btoa(data.password),
        };
        loginDealer(encodedData, {
          onSuccess: (data) => {
            setCookies('accessToken', data?.result?.item?.accessToken);
            history.push({
              pathname: ROUTES_PATH.ROUTE_HOME.PATH,
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          },
        });
      }
    },
    [loginSuccess, storeMasterId, storeId, logoutDealer, loginDealer, lineUid, displayName, userId],
  );

  return (
    <Spin spinning={isLoginDealerPending || isGetStoreQrPending || isLogoutDealerPending}>
      <StyledContainer>
        {loginSuccess === true ? (
          <>
            <RenderForm
              control={control}
              setValue={setValue}
              getValues={getValues}
              forms={FORM_SHOW_LOGGED_IN()}
            />
            <ContainerButton center>
              <ButtonTheme useFor="LOGOUT_DEALER" onClick={handleSubmit(onSubmit)}></ButtonTheme>
            </ContainerButton>
          </>
        ) : (
          <>
            <RenderForm
              control={control}
              setValue={setValue}
              getValues={getValues}
              forms={FORM_LOGIN_DEALER()}
            />
            <ContainerButton center>
              <ButtonTheme useFor="LOGIN_DEALER" onClick={handleSubmit(onSubmit)}></ButtonTheme>
            </ContainerButton>
          </>
        )}
      </StyledContainer>
    </Spin>
  );
};
